module.exports = __webpack_public_path__ + "img/139353-202907-1753@3x.fee85a4a.png";